import MarketBase from 'src/common/components/marketBase';
import EventPrice from 'src/components/eventPrice';
import './style.scss';

interface IProps {
    eventName: string;
    eventPrice: number;
    marketBase?: number;
};

const MarketSelectItem = ({ eventName, eventPrice, marketBase }: IProps) => (
    <div className="B-market-select-item">
        <p className="">
            {eventName}
            <MarketBase base={marketBase} />
        </p>

        <EventPrice price={eventPrice} />
    </div>
);

export default MarketSelectItem;